import { render, staticRenderFns } from "./ProcedureEdit.vue?vue&type=template&id=2fdc50ec&scoped=true&"
import script from "./ProcedureEdit.vue?vue&type=script&lang=js&"
export * from "./ProcedureEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProcedureEdit.vue?vue&type=style&index=0&id=2fdc50ec&prod&lang=scss&scoped=true&"
import style1 from "./ProcedureEdit.vue?vue&type=style&index=1&id=2fdc50ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdc50ec",
  null
  
)

export default component.exports